import { VehicleType } from "@/src/types/types";

export type VehicleSelectorNavigationView =
  | "homePageView"
  | "auctionWizardView";

export const VEHICLE_TYPES: readonly VehicleType[] = [
  VehicleType.CAR,
  VehicleType.MOTO,
  VehicleType.CARAVAN
];

export const VEHICLE_TYPE_LABEL_KEYS: Record<VehicleType, string> = {
  [VehicleType.CAR]: "vehicleType.car",
  [VehicleType.MOTO]: "vehicleType.moto",
  [VehicleType.CARAVAN]: "vehicleType.caravan"
};

export const VEHICLE_TYPE_HOME_PATHS: Record<VehicleType, string> = {
  [VehicleType.CAR]: "/",
  [VehicleType.MOTO]: "/moto",
  [VehicleType.CARAVAN]: "/caravan"
};

export const VEHICLE_TYPE_AUCTION_BASE_PATHS: Record<VehicleType, string> = {
  [VehicleType.CAR]: "/auction",
  [VehicleType.MOTO]: "/moto/auction",
  [VehicleType.CARAVAN]: "/caravan/auction"
};
